
<template>
      <div id="agInvalidPage">
        <div id="agInvalidPage-invalid">
            <fa icon="heart-broken"/>
            <div>Invalid license. Please contact Wecom</div>
            <b-button class="agTextButton" @click="refreshButton_click">Refresh</b-button>
        </div>
      </div>
</template>






<script>

// components


// modules


export default {
    name: "ag-invalid-page",
    components: {

    },
    props:{
        
    },
    data(){
        return {
        };
    },
    computed: {

    },
    watch: {
      
    },

    created() {

    },

    mounted() {
      
    },

    methods: {

        // UI Events

        refreshButton_click() {
            window.location.reload();
        }

        // emitted Events


        // other
    }
}

</script>






<style scoped lang="css">

    #agInvalidPage-invalid 
    {
        position: absolute;
        left: 50%;
        top: 50%;
        margin-left: -307.0px;
        margin-top: -88.0px;
        font-size: 36px;
        color: lightgray;
    }

    #agInvalidPage-invalid svg
    {
        font-size: 60px;
    }

</style>



// WEBPACK FOOTER //
// src/components/InvalidPage.vue